/**
 * Wizard step definitions for the Loan Application wizard.
 *
 * Each entry defines the step label shown in the stepper and the
 * react-hook-form field-name array used for per-step validation.
 */
export const WIZARD_STEPS = [
  {
    index: 0,
    label: "Deal Summary",
    fieldNames: [
      "details.loanTypeId",
      "details.propertyTypeId",
      "details.units",
      "details.propertyUseTypeId",
      "details.countryId",
      "details.stateId",
      "details.address",
      "details.amount",
      "details.estimatedValue",
      "details.cashOutAmount",
      "details.landCost",
      "details.totalSoftCostSpent",
      "details.totalHardCostSpent",
      "details.additionalInvestorEquity",
    ],
  },
  {
    index: 1,
    label: "Borrower Information",
    fieldNames: [
      "applicant.firstName",
      "applicant.lastName",
      "applicant.email",
      "applicant.phoneNumber",
      "applicant.mobileNumber",
      "applicant.ficoScore",
      "applicant.liquidity",
      "applicant.netWorth",
      "applicant.ownershipPercentage",
      "applicant.isUsCitizen",
      "applicant.hasBeenBankruptcy",
    ],
  },
  {
    index: 2,
    label: "Additional Details",
    fieldNames: [
      "referrer.firstName",
      "referrer.lastName",
      "referrer.email",
    ],
  },
];

export const TOTAL_STEPS = WIZARD_STEPS.length;

